import ADIColors from "@NA/Utils/ADIColors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { FC } from "react";
import { css } from "styled-components";
import { Session } from "@NA/Overrides/Services/SessionService";
import getColor from "@insite/mobius/utilities/getColor";

interface OwnProps {
    product: ProductModel;
    extendedStyles?: ADIProductDescriptionStyles;
    sourceName: string;
    session: Session;
}

type Props = OwnProps;

export interface ADIProductDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
}

export const adiProductDescriptionStyles: ADIProductDescriptionStyles = {
    productDetailLink: {
        css: css`
            width: 100%;
        `,
        typographyProps: {
            color: "text.main",
            css: css`
                width: 100%;
                ${wrapInContainerStyles}
                word-break: break-word;
                display: -webkit-box !important;
                line-clamp: 3 !important;
                -webkit-line-clamp: 3 !important;
                -webkit-box-orient: vertical;
                overflow: hidden !important;
                color: ${ADIColors.darkBlack3} !important;
                font-weight: 600;
                font-size: 14px;
                line-height: normal;
                &:hover {
                    color: ${getColor("text.main")} !important;
                    text-decoration: underline;
                }
            `,
        },
    },
};
const ADIProductDescription: FC<Props> = ({ product, extendedStyles, sourceName, session }) => {
    const [styles] = React.useState(() => mergeToNew(adiProductDescriptionStyles, extendedStyles));
    const description = product.productTitle ? product.productTitle : product.shortDescription;
    const urlSegment = `/Product/${product.urlSegment}`;

    let productDetailPath = product.productUri;

    if (!productDetailPath) {
        productDetailPath = product.productDetailUrl ? product.productDetailUrl : urlSegment;
    }

    const clickHandler = () => {
        sessionStorage.setItem("item_list_name", sourceName);
    };

    return productDetailPath ? (
        <Link
            {...styles.productDetailLink}
            href={productDetailPath}
            alt={`See product details for ${description}`}
            data-test-selector="productDescriptionLink"
            onClick={clickHandler}
        >
            {description}
        </Link>
    ) : (
        <Typography {...styles.productDetailDescription}>{description}</Typography>
    );
};
export default ADIProductDescription;

